import React from 'react';
import { useDispatch } from 'react-redux';
import numeral from 'numeral';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { cleanUpBomData } from 'product_tabs/tab_parts/bomSlice';

const Parts = ({ subTotal, selected }) => {
  const dispatch = useDispatch();

  if (!selected) return null;

  const onDelete = () => {
    dispatch(cleanUpBomData(true));
  }

  return (
    <div className="cart-section stencils">
      <div className="title">
        Electronic Components
        <button type="button" onClick={onDelete} className="btn btn-link float-end btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="price">
        {subTotal === undefined ? null : `$${numeral(subTotal).format('0,0.00')}`}
      </div>
      <div className="toggle-details">
      </div>
    </div>
  )
}

export default Parts;
